/** UI primitives remain unchanged */
export function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-2 text-sm ">
      <div className="text-text-secondary text-[14px] font-inter font-normal not-italic tracking-[-0.01em] whitespace-nowrap flex-shrink-0">
        {label}
      </div>
      <div className="text-text-primary text-right font-inter font-normal not-italic   tracking-[-0.01em] align-bottom break-all">
        {children}
      </div>
    </div>
  );
}
